/* Orvia · storefront filtering with Section Rendering API */
(() => {
  class FacetsForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.sectionId = this.dataset.sectionId;
      let timer;
      this.form.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => this.apply(), 500); });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
      document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (link && this.closest('.shopify-section').contains(link)) { e.preventDefault(); this.render(link.href); }
      });
      window.addEventListener('popstate', () => this.render(window.location.href, false));
    }
    apply() {
      const params = new URLSearchParams(new FormData(this.form));
      for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
      this.render(`${window.location.pathname}?${params.toString()}`);
    }
    async render(url, push = true) {
      const section = this.closest('.shopify-section');
      section.setAttribute('aria-busy', 'true');
      const sep = url.includes('?') ? '&' : '?';
      const html = await (await fetch(`${url}${sep}section_id=${this.sectionId}`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['[data-facets-results]', '[data-facets-active]', '[data-facets-count]'].forEach((sel) => {
        const fresh = doc.querySelector(sel), cur = section.querySelector(sel);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
      if (!this.form.contains(document.activeElement)) {
        const freshForm = doc.querySelector('facets-form form');
        if (freshForm) this.form.innerHTML = freshForm.innerHTML;
      }
      section.removeAttribute('aria-busy');
      if (push) window.history.pushState({}, '', url);
    }
  }
  customElements.define('facets-form', FacetsForm);
})();
